<div class="pt-3 TABS">
  <m-tab-view
    *ngIf="tabGroup"
    [(activeIndex)]="activeIndex"
    [tabPanelHeaders]="tabPanelHeaders"
    (activeIndexChange)="tabChange($event)"
    class="result-tabs">
    <ng-template
      *ngFor="let tab of tabElements; let index = index"
      [mTabIndex]="index">
      <div
        *ngIf="activeIndex === index"
        [class]="tab.literalId"
        [ngClass]="{
          'flex flex-wrap items-end justify-start gap-6':
            dashboardLiteralId === 'measured-benchmarks' &&
            tab.literalId === 'portfolioTab',
        }">
        <div
          *ngFor="let tabElement of tab.elements"
          [ngSwitch]="tabElement.layoutType"
          class="{{ tabElement.layoutType }}">
          <portal-native-sections-template
            *ngIf="
              !nativeSectionsService
                .getWrapperComponentType()
                .includes(tabElement.layoutType)
            "
            [item]="tabElement"
            [fieldDefinitions]="fieldDefinitions"
            [filters]="filters">
          </portal-native-sections-template>
          <portal-context-bar
            *ngSwitchCase="'CONTEXT_BAR' || 'FILTER_SET'"
            [contextItem]="tabElement"
            [fieldDefinitions]="fieldDefinitions"
            [filters]="filters">
          </portal-context-bar>
        </div>
      </div>
    </ng-template>
  </m-tab-view>
</div>
